import React, { useState, useEffect } from "react";
import * as AiIcons from "react-icons/ai";
import * as IoIcons from "react-icons/io";
import { FcBullish } from "react-icons/fc";
import { FaLuggageCart } from "react-icons/fa";
import { MdHelp, MdLogout } from "react-icons/md";
import { TiShoppingCart } from "react-icons/ti";
import { BsCashCoin, BsChevronDown, BsMegaphone } from "react-icons/bs";
import { FaSackDollar } from "react-icons/fa6";
import { FaChartLine } from "react-icons/fa";
import { LiaFileInvoiceSolid } from "react-icons/lia";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { ChevronFirst, ChevronLast } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import Logo from "../image/manaviea_attire_colorful_logo.png";
import pinkki from "../image/pinkki.jpg";
import  "../components/sidebarbeautiful.css";



const Menus = [

  {
    title: "Home",
    icon: <AiIcons.AiFillHome color="black" />,
    allowedRoles: ["ROLE_SELLER", "ROLE_ADMIN"],

    subMenus: [
      { title: "DashBoard", src: "/home", icon: <IoIcons.IoIosPaper /> },
    ],
  },
  {
    title: "Sales",
    icon: <FaChartLine color="black" />,
    allowedRoles: ["ROLE_SELLER", "ROLE_ADMIN"],

    subMenus: [
      { title: "Sales", src: "/salepage", icon: <IoIcons.IoIosPaper /> },
      { title: "Sales Report", src: "/sale/product-sale-report", icon: <IoIcons.IoIosPaper /> },
      { title: "Customer Report", src: "/sale/customer-transactions-report", icon: <IoIcons.IoIosPaper /> },
    ],
  },
  {
    title: "Stock",
    icon: <FaLuggageCart />,
    allowedRoles: ["ROLE_SELLER", "ROLE_ADMIN"],
    subMenus: [
      { title: "Stock Report", src: "/stock/stock-report", icon: <IoIcons.IoIosPaper /> },
      { title: "Product", src: "/stock/addproduct", icon: <IoIcons.IoIosPaper /> },
    ],
  },
  {
    title: "Purchase",
    icon: <TiShoppingCart />,
    allowedRoles: ["ROLE_ADMIN"],
    subMenus: [
      { title: "Purchase", src: "/purchase", icon: <IoIcons.IoIosPaper /> },
      { title: "Purchase Report", src: "/purchase/product-purchase-report", icon: <IoIcons.IoIosPaper /> },
      { title: "Supplier Report", src: "/purchase/supplier-transactions-report", icon: <IoIcons.IoIosPaper /> },
    ],
  },
  {
    title: "Cash Book",
    icon: <BsCashCoin />,
    allowedRoles: ["ROLE_ADMIN"],
    subMenus: [{ title: "Cash Book", src: "/cashbook", icon: <IoIcons.IoIosPaper /> }],
  },
  {
    title: "Income & Expense",
    icon: <FaSackDollar />,
    allowedRoles: ["ROLE_ADMIN"],
    subMenus: [
      { title: "Expense Input", src: "/income-expense/expense-input", icon: <IoIcons.IoIosPaper /> },
      { title: "Expense Report", src: "/income-expense/expense-report", icon: <IoIcons.IoIosPaper /> },
      { title: "Profit/Loss", src: "/income-expense/profit-loss", icon: <IoIcons.IoIosPaper /> },
    ],
  },
  {
    title: "Quotation",
    icon: <LiaFileInvoiceSolid />,
    allowedRoles: ["ROLE_ADMIN"],
    subMenus: [{ title: "Quotation", src: "/quotation", icon: <IoIcons.IoIosPaper /> }],
  },
  {
    title: "Marketing and Collection",
    icon: <BsMegaphone />,
    allowedRoles: ["ROLE_ADMIN"],
    subMenus: [
      { title: "Marketing and Collection", src: "/marketing/marketing-due-collection", icon: <IoIcons.IoIosPaper /> },
      { title: "Employee Setup", src: "/marketing/employee-setup", icon: <IoIcons.IoIosPaper /> },
    ],
  },
  {
    title: "Help Center and Contact",
    icon: <MdHelp />,
    allowedRoles: ["ROLE_ADMIN"],
    subMenus: [
      { title: "Open Support Tickets", src: "/help-center/open-support-ticket", icon: <IoIcons.IoIosPaper /> },
      { title: "My Support Ticket", src: "/help-center/my-support-ticket", icon: <IoIcons.IoIosPaper /> },
    ],
  },
];

const SidebarBeautiful = (props) => {
  const [menuItems, setMenuItems] = useState(Menus);
  const [open, setOpen] = useState(true);
  const [activeIndex, setActiveIndex] = useState(null);
  const [activeSubIndex, setActiveSubIndex] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  const userRole = localStorage.getItem("role");

  // Filter SidebarData based on the user's role
  const filteredSidebarData = Menus.filter((item) =>
    item.allowedRoles.includes(userRole)
  );


  useEffect(() => {
    const currentPath = location.pathname;
    setMenuItems(filteredSidebarData)
    menuItems.forEach((menu, i) => {
      if (menu.src === currentPath) setActiveIndex(i);
      menu.subMenus?.forEach((sub, j) => {
        if (sub.src === currentPath) {
          setActiveIndex(i);
          setActiveSubIndex(j);
        }
      });
    });
  }, [location.pathname]);

  const toggleSidebar = () => setOpen(!open);

  const logout = () => {
    localStorage.clear();
    navigate("/");
  };

  const handleSubmenu = (index) => {
    setMenuItems((prev) =>
      prev.map((m, i) => (i === index ? { ...m, isOpen: !m.isOpen } : m))
    );
  };


  return (
    <div 
    
    >

      <motion.div
        animate={{ width: open ? "10vw" : "3vw" }}
        transition={{ type: "spring", damping: 15 }}
        style={{
          position: "fixed",           // ✅ make it fixed
          top: 0,
          left: 0,

          height: "100vh",
          color: "#000000",
          fontWeight: "bold", // ✅ this makes text bold
          display: "flex",
          flexDirection: "column",
          // justifyContent: "space-between",
          backgroundColor:"rgba(0,0,0,0.1)",
          boxShadow: "0 4px 15px rgba(0,0,0,0.3)",

          overflowY: "auto",
          zIndex: 40,
        }}
      >
                {/* Logo */}
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "20px 0" }}>
          <motion.img
            src={Logo}
            alt="Logo"
            style={{
              width: "30%",
              height: "50%",
              borderRadius: "50%",
              marginTop: "3vh",
              objectFit: "cover", // ensures image fills the circle nicely
              border: "2px solid #ccc", // optional
              boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)", // optional
            }}
            animate={{ opacity: open ? 1 : 0, scale: open ? 1 : 0.8 }}
            transition={{ duration: 0.3 }}
          />
        </div>
        <div
          style={{
            width: open? "9vw" : "2.5vw",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "1.5vh",
            color: "#000",
            fontWeight: "700",
            fontSize: "3vw",
            border:"20px"

          }}
        >
          <p style={{
            fontFamily: "Snell Roundhand",
            fontWeight: "bold",
            padding: "2px",
            height: open ? "70px" : "40px",
            fontSize: open ? "1.4vw" : ".7vw",

            borderRadius:"4px"

          }} >
            Manaviea Attire
          </p>

          {/* <img src={lady} alt="" /> */}
        </div>




        {/* Menu List */}
        <ul style={{ listStyle: "none", padding: "0 8px", margin: 0 }}>
          {menuItems.map((menu, index) => (
            <div key={index}>
              <motion.li
                whileHover={{ scale: 1.03 }}
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "8px",
                  borderRadius: "8px",
                  fontWeight: "Bold",
                  fontSize:".7vw",
                  cursor: "pointer",
                  transition: "all 0.2s ease-in-out",
                  background:
                    activeIndex === index && !menu.subMenus
                      ? "transparent"
                      : "transparent",
                  boxShadow:
                    activeIndex === index && !menu.subMenus
                      ? "inset 0 0 5px rgba(0,0,0,0.3)"
                      : "none",
                }}
                onClick={() =>
                  menu.subMenus ? handleSubmenu(index) : navigate(menu.src)
                }
                onMouseEnter={(e) => {
                  if (activeIndex !== index)
                    e.currentTarget.style.background = "#ffffff";
                }}
                onMouseLeave={(e) => {
                  if (activeIndex !== index) {
                    e.currentTarget.style.background = "transparent";
                    e.currentTarget.style.borderRadius = "8px";
                  }

                }}
              >
                <motion.span whileHover={{ rotate: 10 }} style={{ fontSize: "1vw" }}>
                  {menu.icon}
                </motion.span>

                <AnimatePresence>
                  {open && (
                    <motion.span
                      initial={{ opacity: 0, x: -10 }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{ opacity: 0, x: -10 }}
                      style={{
                        marginLeft: ".5vw",
                        fontWeight: "bold",
                        fontSize: ".6vw",
                      }}
                    >
                      {menu.title}
                    </motion.span>
                  )}
                </AnimatePresence>

                {menu.subMenus && open && (
                  <motion.div
                    animate={{ rotate: menu.isOpen ? 180 : 0 }}
                    transition={{ duration: 0.3 }}
                    style={{ marginLeft: "auto" }}
                  >
                    <BsChevronDown />
                  </motion.div>
                )}
              </motion.li>

              {/* Submenus */}
              <AnimatePresence>
                {menu.subMenus && menu.isOpen && (
                  <motion.ul
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.4 }}
                    style={{
                      listStyle: "none",
                      marginLeft: "1vw",
                      marginTop: "4px",
                      overflow: "hidden",
                      padding: 0,
                    }}
                  >
                    {menu.subMenus.map((sub, subIdx) => (
                      <motion.li
                        key={subIdx}
                        whileHover={{ 
                          scale: 1.05,
                        }}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          padding: "6px 8px",
                          borderRadius: "3px",
                          cursor: "pointer",
                          fontSize: ".8vw",
                          transition: "all 0.2s",
                          background:
                            activeSubIndex === subIdx && activeIndex === index
                              ? "#d75b8c"
                              : "transparent",
                          color:
                            activeSubIndex === subIdx && activeIndex === index
                              ? "#000000"
                              : "#000000",
                        }}
                        onClick={() => {
                          navigate(sub.src);
                          setActiveSubIndex(subIdx);
                          setActiveIndex(index);
                        }}
                        onMouseEnter={(e) => {
                          if (!(activeSubIndex === subIdx && activeIndex === index)) {
                            e.currentTarget.style.background = "#d75b8c";
                          
                            e.currentTarget.style.borderRadius = "4px";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (!(activeSubIndex === subIdx && activeIndex === index)) {
                            e.currentTarget.style.background = "transparent";
                
                          }
                        }}
                    
                      >
                        {sub.icon}
                        {open && <span>{sub.title}</span>}
                      </motion.li>
                    ))}
                  </motion.ul>
                )}
              </AnimatePresence>
            </div>
          ))}
        </ul>

        {/* Logout */}
        <motion.button
          whileTap={{ scale: 0.95 }}
          onClick={logout}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "12px 0",
            backgroundColor: "#000000",
            color: "white",
            border: "none",
            cursor: "pointer",
            transition: "all 0.2s",
            borderRadius: "8px",
            borderTopRightRadius: "8px",
            fontWeight: "500",
            fontSize: "15px",
            marginBottom: "0px",
            marginRight: ".5vw",
            width:open?"8vw":"2.2vw"


          }}
          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#115e59")}
          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#000000")}
        >
          <MdLogout style={{ fontSize: "20px" }} />
          {open && <span>Logout</span>}
        </motion.button>
      </motion.div>

      {/* Toggle Button */}
      <button
        onClick={toggleSidebar}
        style={{
          position: "absolute",
          top: "16px",
          left: "10px",
          zIndex: 50,
          backgroundColor: "#000000",
          color: "white",
          width: "1.5vw",
          height: "1.5vw",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
          border: "none",
          cursor: "pointer",
          transition: "all 0.2s",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#115e59")}
        onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#000000")}
      >
        {open ? <ChevronFirst
        style={{
          width:"1.5vh"
        }}
         /> : <ChevronLast
         style={{
          width:"1.5vh"
         }}
          />}
      </button>
    </div>
  );
};

export default SidebarBeautiful;
